var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "-3 -4 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45837 16.7917H15.5V18.0834H6.45837V16.7917Z",
    fill: "#2F893D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45837 19.375H15.5V20.6667H6.45837V19.375Z",
    fill: "#2F893D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87922 13.6594C7.91151 13.6594 11.3344 12.4323 15.5 12.4323C19.6657 12.4323 23.0886 13.6594 23.1209 13.6594C23.25 13.6917 23.3469 13.724 23.4761 13.724C23.9282 13.724 24.348 13.4333 24.4771 12.949C24.6709 12.3677 24.3803 11.7219 23.799 11.5281C23.6698 11.4635 20.0209 10.1719 15.5 10.1719C10.9792 10.1719 7.33025 11.4635 7.1688 11.5281C6.61984 11.7219 6.29691 12.3677 6.49066 12.949C6.7167 13.5625 7.33026 13.8531 7.87922 13.6594Z",
    fill: "#2F893D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58337 24.5417H28.4167V6.45834H2.58337V24.5417ZM26.4792 22.6042H4.52087V8.39584H26.4792V22.6042Z",
    fill: "#2F893D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7344 17.8573L23.8636 16.9854L23.024 17.1469L22.7011 16.3073L22.0552 16.8886L21.3771 16.3073L21.0865 17.1469L20.2146 16.9854L20.3761 17.8573L19.5365 18.1479L20.1177 18.8261L19.5365 19.4719L20.3761 19.7948L20.2146 20.6344L21.0865 20.5052L21.3771 21.3125L22.0552 20.7636L22.7011 21.3125L23.024 20.5052L23.8636 20.6344L23.7344 19.7948L24.5417 19.4719L23.9927 18.8261L24.5417 18.1479L23.7344 17.8573Z",
    fill: "#2F893D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCert);
export default __webpack_public_path__ + "static/media/icon_cert.462c28d8825d67e0986e8404d4711b87.svg";
export { ForwardRef as ReactComponent };